// extracted by mini-css-extract-plugin
export default {"l":"_88a3671af4"};